import ComponentOutlet from './ComponentOutlet';

function BlankPage({ body }) {
	return <ComponentOutlet components={body} />;
}
export default BlankPage;
